import { useEffect, useState } from "react";
import AddTaxCodeModal from "./AddTaxCodeModal";
import { 
    getListCustomerInvoices, 
    addCustomerInvoice, 
    updateCustomerInvoice, 
    deleteCustomerInvoice 
} from "../../../api/CustomerInvoices";

type Invoice = {
    id: number;
    name: string;
    name_company: string;
    tax_code: string;
    address: string;
    province: string;
    // district: string;
    ward: string;
    is_default: boolean;
};

export default function InvoiceInfomation() {
    const [openModal, setOpenModal] = useState(false);
    const [invoices, setInvoices] = useState<Invoice[]>([]);
    const [editingInvoice, setEditingInvoice] = useState<Invoice | null>(null);

    const fetchInvoices = async () => {
        try {
            const response = await getListCustomerInvoices(1, 100);
            if (response.status) {
                setInvoices(response.data.items.map((item: any) => ({
                    ...item,
                    is_default: !!item.is_default
                })));
            }
        } catch (error) {
            console.error("Failed to fetch invoices", error);
        }
    };

    useEffect(() => {
        fetchInvoices();
    }, []);

    const setDefault = async (id: number) => {
        const inv = invoices.find(a => a.id === id);
        if (inv) {
            try {
                await updateCustomerInvoice(id, {
                    ...inv,
                    is_default: true
                });
                fetchInvoices();
            } catch (error) {
                console.error("Failed to set default invoice", error);
            }
        }
    };

    const removeInvoice = async (id: number) => {
        if (window.confirm("Bạn có chắc chắn muốn xóa thông tin hóa đơn này?")) {
            try {
                await deleteCustomerInvoice(id);
                fetchInvoices();
            } catch (error) {
                console.error("Failed to delete invoice", error);
            }
        }
    };

    const handleAddOrUpdate = async (data: any) => {
        try {
            if (editingInvoice) {
                await updateCustomerInvoice(editingInvoice.id, data);
            } else {
                await addCustomerInvoice(data);
            }
            setOpenModal(false);
            setEditingInvoice(null);
            fetchInvoices();
        } catch (error) {
            console.error("Failed to save invoice", error);
        }
    };

    return (
        <div
            className="MuiTabPanel-root styles_tab_panel__NZzZm"
            role="tabpanel"
            aria-labelledby="mui-p-91148-T-6"
            id="mui-p-91148-P-6"
        >
            <div className="MuiGrid-root form-delivery-info-container MuiGrid-container MuiGrid-spacing-xs-2">
                {invoices.map(item => (
                    <div
                        key={item.id}
                        className="MuiGrid-root delivery-card-wrapper MuiGrid-item MuiGrid-grid-md-6"
                        style={{ width: "100%" }}
                    >
                        <div className="styles_wrapCard__HThZ0">
                            <div className="styles_cardHeader__pAOU_">
                                <p className="MuiTypography-root styles_cardTitle__TEgBI delivery-card-title MuiTypography-body1">
                                    {item.is_default ? "Hóa đơn mặc định" : "Hóa đơn khác"}
                                </p>

                                <div className="delivery-card-actions" style={{ display: "flex" }}>
                                    <button
                                        className="MuiButtonBase-root MuiIconButton-root delete-tooltip delete-address-btn"
                                        onClick={() => removeInvoice(item.id)}
                                        type="button"
                                        title="Xóa"
                                    >
                                        <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root delete-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM9 9h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1zm6.5-5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z"></path></svg></span>
                                    </button>

                                    <button
                                        className="MuiButtonBase-root MuiIconButton-root edit-tooltip edit-address-btn"
                                        onClick={() => {
                                            setEditingInvoice(item);
                                            setOpenModal(true);
                                        }}
                                        type="button"
                                        title="Sửa"
                                    >
                                        <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root edit-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"></path></svg></span>
                                    </button>

                                    {!item.is_default && (
                                        <button
                                            className="MuiButtonBase-root MuiIconButton-root set-default-tooltip set-default-btn"
                                            onClick={() => setDefault(item.id)}
                                            type="button"
                                            title="Đặt làm mặc định"
                                        >
                                            <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root location-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"></path><circle cx="12" cy="9" r="2.5"></circle></svg></span>
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="styles_content__hI7MQ">
                                <div className="MuiGrid-root delivery-info-container MuiGrid-container MuiGrid-spacing-xs-1">
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3">
                                        <p className="MuiTypography-root styles_subTitle__e1fVQ name-label MuiTypography-body1">Tên:</p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9">
                                        <p className="MuiTypography-root MuiTypography-body1">
                                            {item.name}
                                        </p>
                                    </div>

                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3">
                                        <p className="MuiTypography-root styles_subTitle__e1fVQ name-label MuiTypography-body1">
                                            Tên Cty:
                                        </p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9">
                                        <p className="MuiTypography-root MuiTypography-body1">
                                            {item.name_company}
                                        </p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3">
                                        <p className="MuiTypography-root styles_subTitle__e1fVQ name-label MuiTypography-body1">
                                            Mã số thuế:
                                        </p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9">
                                        <p className="MuiTypography-root MuiTypography-body1">
                                            {item.tax_code}
                                        </p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3">
                                        <p className="MuiTypography-root styles_subTitle__e1fVQ name-label MuiTypography-body1">
                                            Địa chỉ:
                                        </p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9">
                                        <p className="MuiTypography-root MuiTypography-body1">
                                            {item.address}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/* ADD NEW */}
                <div
                    className="MuiGrid-root add-card-wrapper MuiGrid-item MuiGrid-grid-md-6"
                    style={{ width: "100%" }}
                >
                    <div className="styles_container__2h3uc">
                        <div className="styles_addCard__nPr4_">
                            <button
                                className="MuiButtonBase-root MuiIconButton-root add-address-btn"
                                onClick={() => setOpenModal(true)}
                                type="button"
                            >
                                <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root add-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "var(--primary-color)" }}><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* MODAL */}
            {openModal && (
                <AddTaxCodeModal
                    onClose={() => {
                        setOpenModal(false);
                        setEditingInvoice(null);
                    }}
                    onSubmit={handleAddOrUpdate}
                    initialData={editingInvoice}
                />
            )}
        </div>
    );
}
